module.exports = __webpack_public_path__ + "static/media/carousel4.105c98d7.jpg";